import { application } from "./application"

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
